import { createContext } from "react"

const WindowDimensionsContext = createContext()

export default WindowDimensionsContext